<template>
  <v-list-item class="mb-0 justify-space-between pl-3">
    <v-list-item-avatar>
      <v-img :src="require('@/assets/logo.png')" />
    </v-list-item-avatar>
    <v-list-item-content class="pl-2">
      <v-list-item-title class="text-h3">
        <div
          style="cursor: pointer;"
          @click="goHome"
        >
          <strong class="mr-1 font-weight-black">NEO</strong>
          <span class="primary--text">VISION</span>
<!--          <v-img :src="require('@/assets/logo_kira.c0cd3935.png')" />-->
        </div>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  // Utilities
  import { get } from 'vuex-pathify'
  import { goHome } from '@/util/helpers'

  export default {
    name: 'DefaultDrawerHeader',

    computed: { version: get('app/version') },

    methods: {
      goHome () {
        goHome(this)
      },
    },
  }
</script>
